import React, { useState } from 'react';
import PropTypes from 'prop-types';

import './FilterModal.css';

function FilterModal({ isOpen, onClose, onApply, onReset, filteredMinSubscribers, filteredMaxSubscribers, filteredShowShots }) {
  const [minSubscribers, setMinSubscribers] = useState(filteredMinSubscribers);
  const [maxSubscribers, setMaxSubscribers] = useState(filteredMaxSubscribers);
  const [showShots, setShowShots] = useState(filteredShowShots);

  const handleMinSubscribersChange = (event) => {
    setMinSubscribers(event.target.value);
  };

  const handleMaxSubscribersChange = (event) => {
    setMaxSubscribers(event.target.value);
  };

  const handleShowShotsChange = (event) => {
    setShowShots(event.target.checked);
  };

  const handleResetButtonClick = () => {
    setMinSubscribers('');
    setMaxSubscribers('');
    setShowShots(true);
    onReset();
  };

  const handleApplyButtonClick = () => {
    onApply(minSubscribers, maxSubscribers, showShots);
    onClose();
  };

  const closeButtonClick = () => {
    onApply(minSubscribers, maxSubscribers, showShots);
    onClose();
  };

  return (
    <div className={`filter-modal ${isOpen ? 'open' : ''}`}>
        <div className="filter-modal-content">
        <div className="filter-modal-header">
        <h2>필터</h2>
        <button className="filter-modal-close-button" onClick={onClose}>X</button>
        </div>
        <div className="filter-section">
          <label>최소 구독자 수:</label>
          <input type="text" value={minSubscribers} onChange={handleMinSubscribersChange} />
        </div>
        <div className="filter-section">
          <label>최대 구독자 수:</label>
          <input type="text" value={maxSubscribers} onChange={handleMaxSubscribersChange} />
        </div>
        <div className="filter-section">
          <label>쇼츠 (구현 중입니다):</label>
          <input disabled={true} type="checkbox" checked={showShots} onChange={handleShowShotsChange} />
          <label style={{ color:"red" }}>정렬 기능 추가로 인해 리뉴얼 중입니다.</label>
        </div>
        <div className="filter-buttons">
          <button onClick={handleResetButtonClick}>초기화</button>
          <button onClick={handleApplyButtonClick}>적용</button>
        </div>
      </div>
    </div>
  );
}

FilterModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  filteredMinSubscribers: PropTypes.string,
  filteredMaxSubscribers: PropTypes.string,
  filteredShowShots: PropTypes.bool,
};

export default FilterModal;
